<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";

const props = defineProps<{
  redirect: () => void;
}>();
</script>

<template>
  <div class="flex flex-row items-center gap-4 bg-lightest-grey-color justify-center py-5 px-4 rounded-lg">
    <SvgIcon name="create" class="w-6 h-6 text-medium-grey-color shrink-0"></SvgIcon>
    <div class="flex flex-col">
      <span class="body_regular text-medium-grey-color">
        Aucune session disponible. Rendez-vous
        <a class="underline cursor-pointer text-primary-blue-color" @click="redirect()">
          sur la page de la formation
        </a>
        ou dans votre LMS pour créer une session, puis rafraîchissez la page pour inscrire les participants à cette
        session.
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
